"use client";
import ResourceFilterAndBannerWrapper from "@/app/components/filters/ResourceFilterAndBannerWrapper";
import { Flashcard } from "@tsTypes/flash-schema";
import { CurrentTopicInfo, Resources } from "@tsTypes/subject-schema";
import { useCheckUserAccess } from "@utils/accessChecks";
import { useSubTopicMeta } from "../../../../../../../components/CoreDataProvider";
import LinkedTopicResourceBanner from "../../../../components/banners/LinkedTopicResourceBanner";
import RestrictedResourceBanner from "../../../../components/banners/RestrictedResourceBanner";
import FlashCardDeck from "./FlashcardDeck/FlashCardDeck";

export default function FlashLayout({
  allFlashcards,
  subjectName,
  subjectDocumentId,
  topicDocumentId,
  subTopicDocumentIds,
  subTopicDocumentId,
  linkedResource,
}: {
  allFlashcards: Flashcard[] | undefined;
  subjectName: string;
  subjectDocumentId: string;
  topicDocumentId: string;
  subTopicDocumentIds: CurrentTopicInfo["subTopicDocumentIds"];
  subTopicDocumentId?: string;
  linkedResource: Resources | null;
}) {
  const subTopicMeta = useSubTopicMeta(subTopicDocumentId ?? "");
  const userAccess = useCheckUserAccess("flashcards", subjectDocumentId);
  const subjectNameLower = subjectName.toLowerCase();

  return (
    <>
      <ResourceFilterAndBannerWrapper hasFilters={false}>
        <RestrictedResourceBanner
          resource={"flashcards"}
          subjectDocumentId={subjectDocumentId}
          subjectName={subjectNameLower}
          userAccess={userAccess}
        />
      </ResourceFilterAndBannerWrapper>
      <FlashCardDeck
        flashcards={allFlashcards}
        subjectNameLower={subjectNameLower}
        topicDocumentId={topicDocumentId}
        subjectDocumentId={subjectDocumentId}
        currentSubTopicDocumentId={subTopicDocumentId ?? subTopicDocumentIds}
        disableActions={userAccess !== "Full Access"}
      />
      <LinkedTopicResourceBanner
        subject={subjectNameLower}
        currentResource={"flashcards"}
        linkedResource={linkedResource}
        topicDocumentId={topicDocumentId}
        subTopicDocumentId={subTopicDocumentId}
        subTopicTitle={subTopicMeta?.title}
      />
    </>
  );
}
